// extracted by mini-css-extract-plugin
export default {"name":"NameCellRenderer_name__GJfda","badge":"NameCellRenderer_badge__C-+PK"};